import { useCallback, useState } from "react";
import type { AskVivoPanelState } from "../components/AskVivo/askVivo.types";

export function useAskVivoPanel() {
  const [panel, setPanel] = useState<AskVivoPanelState>({ type: "none" });

  const openPanel = useCallback(
    (next: Exclude<AskVivoPanelState, { type: "none" }>) => {
      setPanel(next);
    },
    [],
  );

  const closePanel = useCallback(() => {
    setPanel({ type: "none" });
  }, []);

  return {
    panel,
    openPanel,
    closePanel,
  };
}
